import api from '@/services/api-service';
import RestResource from '@/services/resources/restResource';

export class ApproachingExpirationWindowResource extends RestResource {
    /**
     *
     * @param {ApiClient} apiClient
     * @param {string} endpoint
     */
    constructor(apiClient, endpoint = 'items/approachingExpirationWindow') {
        super(apiClient, endpoint);
    }

    getAll() {
        return this.find();
    }

    getExpiredInventories() {
        return `${this.api.baseURL}/items/approachingExpirationWindow`;
    }

    getExportPath(dateRange) {
        const pDateRange = dateRange == null ? 60 : dateRange;
        return `${this.api.baseURL}/items/expiration/csv/approachingExpirationWindowItems?dateRange=${pDateRange}`;
    }
}

export default new ApproachingExpirationWindowResource(api);
